// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  EditKind,
} from "./types";


export default __t.row({
  editId: __t.u64().primaryKey().name("edit_id"),
  actor: __t.identity(),
  actorLabel: __t.string().name("actor_label"),
  at: __t.timestamp(),
  get kind() {
    return EditKind;
  },
  targetKind: __t.string().name("target_kind"),
  targetIds: __t.array(__t.string()).name("target_ids"),
  summary: __t.string(),
  undoneBy: __t.option(__t.u64()).name("undone_by"),
  sessionId: __t.option(__t.string()).name("session_id"),
  targetDetail: __t.option(__t.string()).name("target_detail"),
  editGroup: __t.option(__t.string()).name("edit_group"),
});
